import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  const imagekit = import.meta.env.VITE_IMAGEKIT_URL;
  return (
    <div className="relative min-h-screen flex flex-col overflow-hidden bg-[linear-gradient(90deg,_#020024,_#090979_35%,_#00d4ff)]" style={{
      backgroundImage: `url(/images/bg.webp)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      {/* Background Gradient Glow */}
      <div className="absolute inset-0">
        <div className="absolute top-[-200px] left-[-200px] w-[500px] h-[500px] bg-[#00C2A8]/20 blur-[140px] rounded-full" />
        <div className="absolute bottom-[-200px] right-[-200px] w-[500px] h-[500px] bg-[#210040]/30 blur-[140px] rounded-full" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-1 items-center justify-center pr-10">
        {/* Glass Card */}

        <div
          className="w-full max-w-[480px] 
      backdrop-blur-xl 
      border border-white/10 
      shadow-2xl 
      rounded-2xl 
      p-8
      transition-all duration-300
      hover:bg-[#0d304d]/20
    "
        >
          {/* Logo */}
          <div className="flex items-center justify-center">
            <img src="/images/logo.png" alt="logo" className="w-60 mx-10 " />
          </div>

          <Outlet />
        </div>
      </div>
    </div>
  );
}
